import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { operations as reportOperations } from 'store/reports'
import LicenseHeader from './component'

export const LicenseHeaderContainer = ({
  deleteReports,
  fetchLessonProgressReport,
  fetchTrainingReport,
  isFetching,
  netSuiteAsset,
  reportData,
  toggleEditModal,
  skuCode,
}) => {
  return (
    <LicenseHeader
      deleteReports={deleteReports}
      fetchLessonProgressReport={fetchLessonProgressReport}
      fetchTrainingReport={fetchTrainingReport}
      isFetchingReport={isFetching}
      netSuiteAsset={netSuiteAsset}
      reportData={reportData}
      skuCode={skuCode}
      toggleEditModal={toggleEditModal}
    />
  )
}

LicenseHeaderContainer.propTypes = {
  deleteReports: PropTypes.func.isRequired,
  fetchLessonProgressReport: PropTypes.func.isRequired,
  fetchTrainingReport: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  lessonReportData: PropTypes.array,
  netSuiteAsset: PropTypes.object,
  reportData: PropTypes.array,
  skuCode: PropTypes.string,
  toggleEditModal: PropTypes.func.isRequired,
}

const mapStateToProps = ({ reportsManager }, { netSuiteAsset }) => {
  const { product } = netSuiteAsset || {}
  const { programCodes } = product || {}

  const skuCode =
    Array.isArray(programCodes) &&
    ['MSP', 'K5P', 'K8PF'].some(code => programCodes.includes(code))
      ? 'K8P'
      : null
  return {
    skuCode,
    reportData: reportsManager.reports[skuCode] || null,
    isFetching: reportsManager.isFetching[skuCode],
  }
}

const mapDispatchToProps = {
  fetchLessonProgressReport: reportOperations.fetchLessonProgressReport,
  fetchTrainingReport: reportOperations.fetchTrainingReport,
  deleteReports: reportOperations.deleteReports,
  deleteLessonProgressReport: reportOperations.deleteLessonProgressReport,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LicenseHeaderContainer)
